import { Role } from "@/types/auth.types";
/**
 * Get the home route path based on user role
 */
export const getHomeRoute = (role) => {
    switch (role) {
        case Role.ADMIN:
            return "/admin/home";
        case Role.STAFF:
            return "/staff/home";
        case Role.CLIENT:
            return "/client/home";
        case Role.SURVEYOR:
            return "/surveyor/home";
        case Role.SUBCONTRACTOR:
        case Role.CONTRACTOR:
            return "/contractor/jobs";
        default:
            return "/login";
    }
};
/**
 * Get the route prefix based on user role
 * Returns "/admin" for ADMIN role, "/staff" for STAFF role
 */
export const getRoutePrefix = (role) => {
    switch (role) {
        case Role.ADMIN:
            return "/admin";
        case Role.STAFF:
            return "/staff";
        default:
            return "/admin"; // Default to admin for backward compatibility
    }
};
